import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import Navbar from './components/landing/header/Navbar.js';
import Login from './components/Login/Login.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isProd } from './utils/Environment.js';


// In production: 12h session, 10m warning
// In development: 2m session, 1m warning
const SESSION_DURATION_MINUTES = isProd ? 12 * 60 : 2;
const SESSION_WARNING_MINUTES = isProd ? 10 : 1;

const SESSION_DURATION = SESSION_DURATION_MINUTES * 60 * 1000; // ms
const WARNING_OFFSET = SESSION_WARNING_MINUTES * 60 * 1000;    // ms

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  // Track if timers are already running
  const sessionTimeoutRef = useRef(null);
  const warningTimeoutRef = useRef(null);

  useEffect(() => {
    const isFirstVisit = !localStorage.getItem("hasVisited");

    const timeout = setTimeout(() => {
      setLoading(false);
      localStorage.setItem("hasVisited", "true");
    }, isFirstVisit ? 6000 : 2000);

    return () => clearTimeout(timeout);
  }, []);

  // 🔹 Handle session expiration + warning toast
  useEffect(() => {
    if (isAuthenticated) {
      // prevent duplicate timers
      if (sessionTimeoutRef.current || warningTimeoutRef.current) return;

      sessionTimeoutRef.current = setTimeout(() => {
        setIsAuthenticated(false);
        setSessionExpired(true);
        localStorage.removeItem("sessionActive");
        localStorage.removeItem("token");
        sessionTimeoutRef.current = null;
        warningTimeoutRef.current = null;
      }, SESSION_DURATION);

      // warningTimeoutRef.current = setTimeout(() => {
      //   toast.warning(`⚠️ Session will expire in ${SESSION_WARNING_MINUTES} minute(s)!`, {
      //     position: "top-right",
      //     autoClose: 5000,
      //   });
      // }, SESSION_DURATION - WARNING_OFFSET);

    } else {
      // clear timers on logout
      clearTimeout(sessionTimeoutRef.current);
      clearTimeout(warningTimeoutRef.current);
      sessionTimeoutRef.current = null;
      warningTimeoutRef.current = null;
    }
  }, [isAuthenticated]);

  // 🔹 On app load, check if session exists
  useEffect(() => {
    const session = localStorage.getItem("sessionActive");
    if (session) {
      setIsAuthenticated(true);
    }
  }, []);

  // 🔹 Mock login handler (replace with real login logic)
  const handleLogin = () => {
    setIsAuthenticated(true);
    setSessionExpired(false);
    localStorage.setItem("sessionActive", "true");
  };

  return (
    <>
      <Router>
        <Navbar setIsAuthenticated={setIsAuthenticated} setSessionExpired={setSessionExpired} />
        <Switch>
          <Route exact path='/'>
            {isAuthenticated ? <Redirect to="/dashboard" /> : <Login onLogin={handleLogin} />}
          </Route>

          <Route exact path='/dashboard'>
            {isAuthenticated ? <Landing /> : <Redirect to="/" />}
          </Route>
        </Switch>

        {/* Show a message if session expired */}
        {sessionExpired && (
          <div className="session-expired-banner">
            Session expired. Please log in again.
          </div>
        )}

        <ToastContainer />
      </Router>
    </>
  );
}

export default App;